(() => {
  const bindCart = (scope = document) => {
    scope.querySelectorAll('[data-babaa-cart]').forEach((cartRoot) => {
      if (cartRoot.dataset.bound) return;
      cartRoot.dataset.bound = 'true';

      const form = cartRoot.querySelector('#babaa-cart-form');
      const updateBtn = cartRoot.querySelector('.babaa-cart__update');
      if (!form) return;

      const submitUpdates = () => {
        if (updateBtn) updateBtn.click();
        else form.requestSubmit();
      };

      cartRoot.querySelectorAll('[data-qty-step]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const wrap = btn.closest('.babaa-cart__quantity');
          const input = wrap?.querySelector('[data-qty-input]');
          if (!input) return;

          const step = Number(btn.getAttribute('data-qty-step')) || 0;
          const min = Number(input.min) || 0;
          const next = Math.max(min, (Number(input.value) || min) + step);
          input.value = String(next);
          submitUpdates();
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindCart());
  } else {
    bindCart();
  }

  document.addEventListener('shopify:section:load', (event) => bindCart(event.target));
})();
